/**
 * PREP-IA-1 — rehearsal house, not a Response overflow tab.
 * Existing readiness / drill / playbook desks and Live APIs remain unchanged.
 */
import { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { html, M, Ico, stay, SOFT } from "./ui.js";
import { DrillDesk } from "./drill-desk.js";
import { ReadinessDesk, SopDesk } from "./prepare-desk.js";
import { confirmLeaveSeat } from "./shell-wayfind.js";

const PREP_TABS = [
  { id: "readiness", label: "Readiness", verb: "Measure", say: "What will fail first if an incident starts now." },
  { id: "drill", label: "Drills", verb: "Rehearse", say: "Practise the response without inventing a live outbox." },
  { id: "playbook", label: "Site SOP", verb: "Guide", say: "Site standing orders — not AI markdown playbooks." },
];

export default function PreparePrimary({ sub, toast }) {
  const routeAt = PREP_TABS.some((t) => t.id === sub) ? sub : "readiness";
  const [at, setAt] = useState(routeAt);
  useEffect(() => setAt(routeAt), [routeAt]);
  const active = PREP_TABS.find((t) => t.id === at) || PREP_TABS[0];
  const Desk = at === "drill" ? DrillDesk : at === "playbook" ? SopDesk : ReadinessDesk;
  const select = (id) => {
    setAt(id);
    stay("/prepare/" + id);
  };
  const leaveResponse = () => confirmLeaveSeat({
    fromRoute: "/prepare/" + at,
    targetPath: "/response/board",
    objectLabel: "Response",
  });

  return html`
    <div className="sheet prepare-primary desk-craft house-rack house-ia" data-cmc-prepare="prep-ia-1"
      data-cmc-prepare-ux="prep-v2" data-cmc-prepare-wave="1093">
      <div className="wrap prepare-primary__wrap">
        <header className="prepare-v2__hero house-ia__hero">
          <div className="prepare-v2__copy">
            <p className="eyebrow">House · rehearse</p>
            <h1 className="ph">Prepare</h1>
            <p className="psub">${active.say}</p>
          </div>
          <div className="prepare-v2__instrument" data-phase=${at} aria-hidden="true">
            <span className="prepare-v2__orbit prepare-v2__orbit--one"/>
            <span className="prepare-v2__orbit prepare-v2__orbit--two"/>
            <span className="prepare-v2__needle"/>
            <strong>${active.verb}</strong>
            <small>${active.label}</small>
          </div>
          <div className="prepare-v2__hero-actions">
            <button type="button" className="btn btn--ghost btn--sm"
              onClick=${leaveResponse}>
              <${Ico} d="route" w=${14}/> Incidents stay in Response
            </button>
          </div>
        </header>

        <nav className="prepare-primary__tabs prepare-v2__tabs house-ia__tabs" aria-label="Prepare workspaces">
          ${PREP_TABS.map((t) => html`
            <button type="button" role="tab" className="prepare-primary__tab"
              aria-selected=${at === t.id ? "true" : "false"}
              data-on=${at === t.id ? "1" : "0"}
              onClick=${() => select(t.id)}>
              <i className="house-rack__tick" aria-hidden="true"/>
              <span><b>${t.label}</b><em>${t.verb}</em></span>
              <small>${t.say}</small>
            </button>`)}
        </nav>

        <main className="prepare-primary__stage" data-prepare-stage=${at}>
          <${AnimatePresence} mode="wait">
            <${M.div} key=${at} initial=${{ opacity:0, y:10 }}
              animate=${{ opacity:1, y:0 }} exit=${{ opacity:0, y:-5 }}
              transition=${SOFT}>
              <${Desk} toast=${toast}/>
            <//>
          <//>
        </main>
      </div>
    </div>`;
}
